import "./productStyle.css";
import pic from "../../../img/pictureBigProdCat.png";
import css from "../../catalog/catalog.module.css";
import { HandySvg } from "handy-svg";
import iconSrc from "../../../svg/smallProductLike.svg";
import iconSrcCard from "../../../svg/smallProductCard.svg";
import { Link } from "react-router-dom";
import addToCart from "../../../function/addToCard";
import { useState, useEffect } from "react";
import transliterate from "../../../function/transliterate";
import { PhotoProvider, PhotoSlider, PhotoView } from "react-photo-view";
import { getProductHref } from "../../../function/productLink";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../../../firebase";
export default function CatalogProductComponent({
  el,
  index,
  setVisitedProducts,
  visitedProducts,
  setCartCounterC,
  setLikeCounterC,
}) {
  const handleProductClick = (product) => {
    const productId = product;
    // перевіряємо, чи ідентифікатор продукту вже зберігається в масиві visitedProducts
    if (!visitedProducts.includes(productId)) {
      const newVisitedProducts = [...visitedProducts, productId];
      setVisitedProducts(newVisitedProducts);
      // зберігаємо список відвіданих продуктів в localStorage
      localStorage.setItem(
        "visitedProducts",
        JSON.stringify(newVisitedProducts),
      );
    }
  };
  console.log("el", el);

  const [liked, setLiked] = useState(false);
  const [authorsList, setAuthorsList] = useState([]);

  useEffect(() => {
    let isMounted = true;

    const fetchAuthors = async () => {
      try {
        const authorsSnapshot = await getDocs(collection(db, "author"));

        const authors = authorsSnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        if (isMounted) {
          setAuthorsList(authors);
        }
      } catch (error) {
        console.error("Помилка при отриманні авторів:", error);
      }
    };

    fetchAuthors();

    return () => {
      isMounted = false;
    };
  }, []);

  const normalizeNames = (value) => {
    if (Array.isArray(value)) {
      return value.filter(Boolean);
    }

    if (typeof value === "string" && value.trim() !== "") {
      return [value];
    }

    return [];
  };

  const findAuthorByName = (name) => {
    const surname = String(name).trim().split(" ")[0]?.toLowerCase();

    if (!surname) return null;

    return authorsList.find((author) =>
      String(author.name || "")
        .toLowerCase()
        .startsWith(surname),
    );
  };

  const renderAuthorLink = (name) => {
    const foundAuthor = findAuthorByName(name);

    if (foundAuthor?.uid) {
      return (
        <Link className="autorAndHudPSpan" to={`/author/${foundAuthor.uid}`}>
          {name}
        </Link>
      );
    }

    return <span className="autorAndHudPSpan">{name}</span>;
  };

  const renderNames = (value) => {
    const names = normalizeNames(value);

    return names.map((name, idx) => (
      <span key={`${name}-${idx}`}>
        {renderAuthorLink(name)}
        {idx !== names.length - 1 && ", "}
      </span>
    ));
  };
  useEffect(() => {
    // Отримуємо дані з localStorage
    const likedProducts =
      JSON.parse(localStorage.getItem("likedProducts")) || [];

    // Перевіряємо, чи товар є в масиві подобається
    const isLiked = likedProducts.some((product) => product.uid === el.uid);

    // Встановлюємо відповідний стан liked
    setLiked(isLiked);
  }, []);
  const handleLike = () => {
    // Отримуємо дані з localStorage
    let likedProducts = JSON.parse(localStorage.getItem("likedProducts")) || [];

    if (!liked) {
      // Додаємо товар до масиву подобається
      setLikeCounterC((prev) => prev + 1);
      likedProducts.push(el);
    } else {
      // Видаляємо товар з масиву подобається
      setLikeCounterC((prev) => prev + 1);
      const updatedLikedProducts = likedProducts.filter(
        (product) => product.uid !== el.uid,
      );
      likedProducts = updatedLikedProducts;
    }

    // Зберігаємо оновлений масив у localStorage
    localStorage.setItem("likedProducts", JSON.stringify(likedProducts));

    // Змінюємо стан liked
    setLiked(!liked);
  };
  const addingToCart = (id) => {
    addToCart(id);

    setCartCounterC((prev) => prev + 1);
  };
  // const hasFixedSale = el.priceSale && el.priceSale !== "";
  // const hasAction =
  //   el.actionDiscountPercent && Number(el.actionDiscountPercent) > 0;

  // const finalPrice = hasFixedSale
  //   ? Number(el.priceSale)
  //   : hasAction
  //   ? Math.round(el.price - (el.price * el.actionDiscountPercent) / 100)
  //   : Number(el.price);
  const hasFixedSale = el.priceSale && el.priceSale !== "";
  const hasSalePercent =
    el.saleDiscountPercent && Number(el.saleDiscountPercent) > 0;
  const hasAction =
    el.actionDiscountPercent && Number(el.actionDiscountPercent) > 0;

  const finalPrice = hasFixedSale
    ? Number(el.priceSale)
    : hasSalePercent
      ? Math.round(el.price - (el.price * el.saleDiscountPercent) / 100)
      : hasAction
        ? Math.round(el.price - (el.price * el.actionDiscountPercent) / 100)
        : Number(el.price);
  return (
    <div className="productBigInCatWrap">
      <div className="productBigPicture">
        <div className="productBigPictureImgWrap">
          <PhotoProvider>
            <PhotoView src={el.imageList[0]}>
              <img
                src={el.imageList[0]}
                alt={`${el.bookName}`}
                className="productBigPictureImg"
              />
            </PhotoView>
            {/* Додаємо всі зображення до PhotoView для перегляду в повноекранному режимі, окрім першого */}
            {el.imageList.slice(1).map((item, index) => (
              <PhotoView key={index} src={item}>
                <span style={{ display: "none" }} />
              </PhotoView>
            ))}
          </PhotoProvider>
          {el.top === "true" && (
            <div className="topBooksMonthLabel">ТОП місяця</div>
          )}
          {el.bookYear === "true" && (
            <div className="topBooksYersLabel">Книга року</div>
          )}
          {el.novunka === "true" && (
            <div className="newBooksLabel">Новинка</div>
          )}
        </div>
      </div>
      <div className="productBigDescription">
        {/* <div className="autorAndHud">
          <p className="autorAndHudP">
            Автор: <span className="autorAndHudPSpan">{el.textAutor}</span>
          </p>
          <p className="autorAndHudP">
            Художник: <span className="autorAndHudPSpan">{el.picWriter}</span>
          </p>
        </div> */}
        <div className="autorAndHud">
          {el.textAutor && (
            <p className="autorAndHudP">Автор: {renderNames(el.textAutor)}</p>
          )}

          {el.picWriter && (
            <p className="autorAndHudP">
              Художник: {renderNames(el.picWriter)}
            </p>
          )}
        </div>
        <h1
          className="bookTitleBigProd"
          onClick={() => handleProductClick(el.uid)}
        >
          <Link className="bookTitleBigProd" to={getProductHref(el)}>
            {" "}
            {el.bookName}
          </Link>
        </h1>
        <div className="pawerWrapBlock">
          {/* <p className="power">Сила</p>
          <p className="powerDescripProdBig">{el.bookPower}</p> */}
          <br />
          <Link to={getProductHref(el)} className="powerDescripProdBig">
            {el.descriptionSe}
          </Link>
        </div>
        <div className="ageLanguageWrapBlock">
          <p className="ageLanguagePBigProd">Формат: {el.bookFormat}</p>
          <p className="ageLanguagePBigProd">
            Кількість сторінок: {el.pageCount}
          </p>
          <p className="ageLanguagePBigProd">Ілюстрації: {el.ilystracii}</p>
          {/* <p className="ageLanguagePBigProd">Призначення: {el.forWho}</p> */}
        </div>

        <div className={css.prodPricLikeCartBigProd}>
          {/* {el.priceSale != "" && (
            <div className={css.newforNeProdFoActions}>
              <div className="prdeProdPricingRotateCart">
                <p className="fullPriceCartNewR">{el.priceSale}</p>
                <p className="salePriceCart">{el.price}</p>
                <p className="fullPriceCartG">грн</p>
              </div>
            </div>
          )}
          {el.priceSale === "" && (
            <div className="prdeProdPricingCartBigProd">
              <div className="prdeProdPricingRotateCart">
                <p className="salePriceCartBigProd">{el.price}</p>
                <p className="fullPriceCartBigProd">грн</p>
              </div>
            </div>
          )} */}
          {/* {hasFixedSale && (
            <div className={css.newforNeProdFoActions}>
              <div className="prdeProdPricingRotateCart">
                <p className="fullPriceCartNewR">{el.priceSale}</p>
                <p className="salePriceCart">{el.price}</p>
                <p className="fullPriceCartG">грн</p>
              </div>
            </div>
          )}

          {!hasFixedSale && hasAction && (
            <div className={css.newforNeProdFoActions}>
              <div className="prdeProdPricingRotateCart">
                <p className="fullPriceCartNewR">{el.price}</p>
                <p className="salePriceCart">{finalPrice}</p>
                <p className="fullPriceCartG">грн</p>
              </div>
            </div>
          )}

          {!hasFixedSale && !hasAction && (
            <div className="prdeProdPricingCartBigProd">
              <div className="prdeProdPricingRotateCart">
                <p className="salePriceCartBigProd">{finalPrice}</p>
                <p className="fullPriceCartBigProd">грн</p>
              </div>
            </div>
          )} */}

          {hasFixedSale && (
            <div className={css.newforNeProdFoActions}>
              <div className="prdeProdPricingRotateCart">
                <p className="fullPriceCartNewR">{el.priceSale}</p>
                <p className="salePriceCart">{el.price}</p>
                <p className="fullPriceCartG">грн</p>
              </div>
            </div>
          )}
          {!hasFixedSale && hasSalePercent && (
            <div className={css.newforNeProdFoActions}>
              <div className="prdeProdPricingRotateCart">
                <p className="fullPriceCartNewR">{el.price}</p>

                <p className="salePriceCart">{finalPrice}</p>
                <p className="fullPriceCartG">грн</p>
              </div>
            </div>
          )}
          {!hasFixedSale && !hasSalePercent && hasAction && (
            <div className={css.newforNeProdFoActions}>
              <div className="prdeProdPricingRotateCart">
                <p className="fullPriceCartNewR">{el.price}</p>
                <p className="salePriceCart">{finalPrice}</p>
                <p className="fullPriceCartG">грн</p>
              </div>
            </div>
          )}
          {!hasFixedSale && !hasSalePercent && !hasAction && (
            <div className="prdeProdPricingCartBigProd">
              <div className="prdeProdPricingRotateCart">
                <p className="salePriceCartBigProd">{finalPrice}</p>
                <p className="fullPriceCartBigProd">грн</p>
              </div>
            </div>
          )}
          <div className="likeCardWrapSmall">
            <div
              className={`likeProductBig${liked ? "Click" : ""}`}
              onClick={handleLike}
            >
              <HandySvg src={iconSrc} width="34" height="31" />
            </div>
            <div
              className="likeProductBig"
              onClick={() => addingToCart(el.uid)}
            >
              <HandySvg src={iconSrcCard} width="28.33" height="28.33" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
